import { axiosInstance } from '../../../shared/api';

export async function sendChatMessage(message) {
	try {
		const response = await axiosInstance.post('chat', { message });
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		console.error('Error sending chat message:', error);
		throw error;
	}
}

export async function getChatHistory() {
	try {
		const response = await axiosInstance.get('chat/history');
		if (response.status === 200) {
			return response.data;
		}
	} catch (error) {
		console.error('Error fetching chat history:', error);
		throw error;
	}
}
